<template>
    <new-select-option
        autosubmit
        name="package"
        prefix="Package:"
        :model-value="props.value ? props.value : ''"
        @update:modelValue="handleValueUpdate"
        :options="list"
    ></new-select-option>
</template>
<script setup>
import { computed, defineProps, reactive, onMounted, defineEmits } from "vue";
import emitter from "tiny-emitter/instance";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
    teamId: {
        type: Number,
    },
    value: {
        type: String,
    },
    packages: {
        type: Array,
    },
});
const state = reactive({
    packages: props.packages,
});

const list = computed(() => {
    const source = state.packages;
    let data = [
        {
            label: "",
            value: "",
        },
    ];
    if (source?.length) {
        data = [
            ...data,
            ...source.map((pkg) => ({
                label: pkg.name,
                value: pkg.id,
            })),
        ];
    }

    return data;
});

emitter.on("package-updated", (data) => {
    state.packages = data;
});

function handleValueUpdate(value) {
    emit("update:modelValue", value);
}

async function getData() {
    const teamId = props.teamId ? props.teamId : "";
    state.packages = (await axios.get(`/package?team_id=${teamId}`)).data;
    return state.packages;
}
</script>
